import { createAction, props } from '@ngrx/store';
import { Quote } from '@shared/models/quote';

export const setPreferredQuote = createAction('[Quotes] Set Preferred Quote', props<{ quoteId: number }>());

export const setPreferredQuoteSuccess = createAction('[Quotes] Set Preferred Quote Success', props<{ quote: Quote }>());

export const setPreferredQuoteFailure = createAction('[Quotes] Set Preferred Quote Failure', props<{ error: any }>());
